import type { AgendaEvent } from "../types";

/**
 * La programació anterior ja forma part de l'Arxiu. La nova agenda es
 * publicarà quan dates, espais i cartells estiguin confirmats.
 */
export const agendaEvents: AgendaEvent[] = [];
